module.exports = __webpack_public_path__ + "img/robot-img1.51bd929f.png";